import { render, staticRenderFns } from "./FormElementAddress.vue?vue&type=template&id=5b9df117"
import script from "./FormElementAddress.vue?vue&type=script&lang=js"
export * from "./FormElementAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports